import { FormField } from '@/components/custom/erp';

export const BasicInfoTab = ({ formMode }: { formMode: 'add' | 'edit' | 'view' }) => (
  <div className='p-4'>
    <div className='grid grid-cols-1 gap-x-8 space-y-2 lg:grid-cols-5 lg:space-y-0'>
      <div className='col-span-5 space-y-2'>
        <FormField
          label='Mã loại vật tư'
          className='grid grid-cols-[160px,1fr] items-center'
          name='ma_lvt'
          type='text'
          disabled={formMode === 'view'}
          labelClassName='font-medium'
        />
        <FormField
          label='Tên loại vật tư'
          className='grid grid-cols-[160px,1fr] items-center'
          name='ten_lvt'
          type='text'
          disabled={formMode === 'view'}
          labelClassName='font-medium'
        />
        <FormField
          label='Tên khác'
          className='grid grid-cols-[160px,1fr] items-center'
          name='ten_lvt2'
          type='text'
          disabled={formMode === 'view'}
          labelClassName='font-medium'
        />
        <FormField
          label='Trạng thái'
          className='grid grid-cols-[160px,1fr] items-center'
          name='status'
          type='select'
          disabled={formMode === 'view'}
          labelClassName='font-medium'
          options={[
            { value: '1', label: '1. Còn sử dụng' },
            { value: '0', label: '0. Không sử dụng' }
          ]}
        />
      </div>
    </div>
  </div>
);
